import {
  updateStateAfterWidgetOptionChange,
  isMdaeWidgetOptionChangeEvent,
} from "../../mdae-framework";
import { cloneDeep } from "lodash";
import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
  isAsyncFailure,
} from "async-ops";
import { IS_CODER_WORKFLOW_ENABLED_FOR_CLIENT } from "../services/is-coder-worklow-enabled-for-client";
import Guid from "devextreme/core/guid";
import { convertDate } from "../../../utils/dateUtils";
import { GET_ADMISSION_TYPE_LIST } from "../services/get-admission-type-list";
import { GET_ADMISSION_SOURCE_LIST } from "../services/get-admission-source-list";
import { GET_DISCHARGE_DISPOSITION } from "../services/get-discharge-disposition";
import { GET_CODER_LIST } from "../services/get-coder-list";
import { GET_PAYER_FINANCIAL_CLASS_LIST } from "../services/get-payer-financial-class-list";
export const TOGGLE_ADD_CASE_MANUAL_POPUP = "TOGGLE_ADD_CASE_MANUAL_POPUP";
export const SET_ADD_CASE_MANUAL_DATA = "SET_ADD_CASE_MANUAL_DATA";
export const SET_ADD_CASE_MANUAL_FLAGS = "SET_ADD_CASE_MANUAL_FLAGS";
export const SET_MANUAL_CASE_FACILITY_LIST = "SET_MANUAL_CASE_FACILITY_LIST";
export const SET_CASE_BILLING_PROVIDERS = "SET_CASE_BILLING_PROVIDERS";
export const SET_CASE_RENDERING_PROVIDERS = "SET_CASE_RENDERING_PROVIDERS";
export const SET_CASE_PROVIDERS = "SET_CASE_PROVIDERS";
export const TOGGLE_SEARCH_PROVIDER_POPUP = "TOGGLE_SEARCH_PROVIDER_POPUP";
export const SET_SEARCH_PROVIDER_POPUP_DATA = "SET_SEARCH_PROVIDER_POPUP_DATA";
export const SET_SEARCH_PROVIDER_POPUP_DATA_MANUALLY =
  "SET_SEARCH_PROVIDER_POPUP_DATA_MANUALLY";
export const SET_ADD_MANUAL_CASE_REFERENCE_DATA =
  "SET_ADD_MANUAL_CASE_REFERENCE_DATA";
export const TOGGLE_VALIDATION_SUMMARY_POPUP =
  "TOGGLE_VALIDATION_SUMMARY_POPUP";
export const SET_DIRTY_ROW_FOR_DATAGRID = "SET_DIRTY_ROW_FOR_DATAGRID";
export const SET_ADD_MANUAL_CASE_FORM_DATA_VALID =
  "SET_ADD_MANUAL_CASE_FORM_DATA_VALID";
export const UPDATE_DATAGRID_DATA = "UPDATE_DATAGRID_DATA";
export const DELETE_DATAGRID_ROW = "DELETE_DATAGRID_ROW";
export const SET_MANUAL_CASE_SAVE_BUTTON_DISABLED = "SET_MANUAL_CASE_SAVE_BUTTON_DISABLED";
export const SET_MANUAL_CASE_PARAMS = "SET_MANUAL_CASE_PARAMS";
export const SET_IS_MANUAL_EXPEDITE_CASE_SEARCH = "SET_IS_MANUAL_EXPEDITE_CASE_SEARCH";
export const SET_IS_SAVE_FROM_VALIDATION_FOR_MANUAL_EXPEDITE_CASE_SEARCH = "SET_IS_SAVE_FROM_VALIDATION_FOR_MANUAL_EXPEDITE_CASE_SEARCH";
const initialError = {
  code: "",
  message: "",
  value: [],
};
export const initialSearchProviderPopupData = {
  provider: { nPI: "" },
  npiName: "",
  launcher: "",
};
export const initialAddCasweManualFormData = {
  admissionDateString: null,
  admitDx: null,
  admitHourValue: null,
  attendingProviderId: null,
  auditCaseLines: [],
  auditCaseParticipants: [],
  billingProviderId: null,
  claimTypeCd: null,
  clinicalTrialIdentifier: null,
  conditionCodes: [],
  diagnosesCaseCodes: [],
  dischargeDateString: null,
  dischargeHourValue: null,
  drgDiagCode: null,
  externalInjuryCodes: [],
  facilityName: null,
  icdProcedureCodes: [],
  investDeviceExmptNo: null,
  occurrenceCodes: [],
  occurrenceSpanCodes: [],
  originalPaymentAmt: null,
  patientAcctNo: null,
  patientFirstName: null,
  patientLastName: null,
  admissionSourceCode: null,
  admissionTypeCode: null,
  patientMRN: null,
  dischargeStatus: null,
  patientType: null,
  refCoderId: null,
  renderingProviderId: null,
  statementFromDateString: null,
  statementToDateString: null,
  visitReasonCodes: [],
  sequenceNo:null,
  roundStartDate:null
};
const initialState = {
  loading: false,
  error: initialError,
  addCaseManualFormData: { ...initialAddCasweManualFormData },
  addCaseManualFlags: {
    isSelectedClaimTypeHospital: false,
    isProviderAudit: false,
    isCoderWorkFlowEnabled: false,
    isSelectedPatientTypeInPatient: true,
    isLinesAllFieldsShown: false,
    lineItemTitle: "",
  },
  searchProviderPopupData: { ...initialSearchProviderPopupData },
};
export default (state = initialState, action) => {
  let newState;
  let dataSourceKey;
  let uniqueRowKey;
  let updatedDatSource;
  let index;
  switch (action.type) {
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncComplete(IS_CODER_WORKFLOW_ENABLED_FOR_CLIENT)(action)) {
        return {
          ...state,
          addCaseManualFlags: {
            ...state.addCaseManualFlags,
            isCoderWorkFlowEnabled: action.response.isCoderWorkFlowEnabled,
          },
        };
      }
      if (isAsyncComplete(GET_ADMISSION_TYPE_LIST)(action)) {
        return {
          ...state,
          admissionTypeList: action.response,
        };
      }
      if (isAsyncComplete(GET_ADMISSION_SOURCE_LIST)(action)) {
        return {
          ...state,
          admissionSourceList: action.response,
        };
      }
      if (isAsyncComplete(GET_DISCHARGE_DISPOSITION)(action)) {
        return {
          ...state,
          dischargeDispositionList: action.response,
        };
      }
      if (isAsyncComplete(GET_CODER_LIST)(action)) {
        return {
          ...state,
          coderList: action.response,
        };
      }
      if (isAsyncOperation(GET_PAYER_FINANCIAL_CLASS_LIST)(action)) {
        return {
          ...state,
          payerFinancialClassList: [],
        };
      }
      if (isAsyncComplete(GET_PAYER_FINANCIAL_CLASS_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          payerFinancialClassList: Array.isArray(response)
            ? response.map((item) => item.description ?? "")
            : [],
        };
      }
      return state;
    case TOGGLE_ADD_CASE_MANUAL_POPUP:
    case SET_MANUAL_CASE_FACILITY_LIST:
    case SET_CASE_BILLING_PROVIDERS:
    case SET_CASE_RENDERING_PROVIDERS:
    case SET_CASE_PROVIDERS:
    case TOGGLE_SEARCH_PROVIDER_POPUP:
    case SET_SEARCH_PROVIDER_POPUP_DATA:
    case SET_ADD_MANUAL_CASE_REFERENCE_DATA:
    case TOGGLE_VALIDATION_SUMMARY_POPUP:
    case SET_ADD_MANUAL_CASE_FORM_DATA_VALID:
    case SET_MANUAL_CASE_SAVE_BUTTON_DISABLED:
      newState = {...state};
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case SET_ADD_CASE_MANUAL_FLAGS:
      return {
        ...state,
        addCaseManualFlags: { ...state.addCaseManualFlags, ...action.data },
      };
    case SET_MANUAL_CASE_PARAMS:
      return {
        ...state,
        saveManualCaseDataParams: action.data.saveManualCaseDataParams
      };
    case SET_IS_MANUAL_EXPEDITE_CASE_SEARCH:
      return {
        ...state,
        isManualExpediteCaseSearch: action.data.isManualExpediteCaseSearch
      };
    case SET_IS_SAVE_FROM_VALIDATION_FOR_MANUAL_EXPEDITE_CASE_SEARCH:
      return {
        ...state,
        isSaveFromValidationForManualExpediteCaseSearch: action.data.isSaveFromValidationForManualExpediteCaseSearch
      };
    case SET_ADD_CASE_MANUAL_DATA:
      newState = {...state};
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else if (action.data?.isForAddRow) {
        dataSourceKey = action.data.dataSourceKey;
        const stepCount = action.data.stepCount;
        const maxCount = action.data.maxCount;
        const isForLinesDataGrid = action.data.isForLinesDataGrid
        const dataSourceObject = newState.addCaseManualFormData[
          dataSourceKey
        ].slice();
        for (var i = 0; i < stepCount; i++) {
          if (dataSourceObject?.length >= maxCount) {
            return {
              ...newState,
              addCaseManualFormData: {
                ...newState.addCaseManualFormData,
                [dataSourceKey]: dataSourceObject,
              },
            };
          }
          dataSourceObject.push(
            isForLinesDataGrid
              ? {
                  unique: new Guid().toString(),
                  isDirty: false,
                  fromServiceDateString:
                    newState.addCaseManualFormData?.statementFromDateString,
                }
              : {
                  unique: new Guid().toString(),
                  isDirty: false,
                }
          );
        }
        return {
          ...newState,
          addCaseManualFormData: {
            ...newState.addCaseManualFormData,
            [dataSourceKey]: dataSourceObject,
          },
        };
      } else {
        newState = {
          ...newState,
          addCaseManualFormData: {
            ...newState.addCaseManualFormData,
            ...action.data.addCaseManualFormData,
          },
        };
      }
      return newState;

    case SET_SEARCH_PROVIDER_POPUP_DATA_MANUALLY:
      return {
        ...state,
        searchProviderPopupData: {
          ...state.searchProviderPopupData,
          ...action.data,
        },
      };
    case SET_DIRTY_ROW_FOR_DATAGRID:
      dataSourceKey = action.data.dataSourceKey;
      uniqueRowKey = action.data.uniqueRowKey;
      updatedDatSource = state.addCaseManualFormData[dataSourceKey]?.slice();
      updatedDatSource.find((x) => x.unique === uniqueRowKey).isDirty = true;
      return {
        ...state,
        addCaseManualFormData: {
          ...state.addCaseManualFormData,
          [dataSourceKey]: updatedDatSource,
        },
      };
    case DELETE_DATAGRID_ROW:
      dataSourceKey = action.data?.dataSourceKey;
      uniqueRowKey = action.data?.unique;
      updatedDatSource = state.addCaseManualFormData[dataSourceKey]?.slice();
      index = updatedDatSource?.findIndex(
          (x) => x.unique === uniqueRowKey
        );
      if(index >= 0)
        updatedDatSource.splice(index, 1);
      return {
        ...state,
        addCaseManualFormData: {
          ...state.addCaseManualFormData,
          [dataSourceKey]: updatedDatSource,
        },
      };
    case UPDATE_DATAGRID_DATA:
      dataSourceKey = action.data?.dataSourceKey;
      uniqueRowKey = action.data?.data.unique;
      updatedDatSource = state.addCaseManualFormData[dataSourceKey]?.slice();
      index = updatedDatSource?.findIndex(
        (x) => x.unique === uniqueRowKey
      );
      if (index >= 0) {
          updatedDatSource[index] = {
            ...updatedDatSource[index],
            ...action.data.data,
          };
      }
      return {
        ...state,
        addCaseManualFormData: {
          ...state.addCaseManualFormData,
          [dataSourceKey]: updatedDatSource,
        },
      };
    default:
      return state;
  }
};
const proDiagnosisGridMaxRowCount = 12;
const ipDiagnosisGridDefaultRowCount = 15;
const opDiagnosisGridDefaultRowCount = 10;
const proDiagnosisGridDefaultRowCount = 10;
const iExternalCauseOfInjuryGridDefaultRowCount = 3;
const ipICDProcedureGridDefaultRowCount = 5;
const opVisitReasonGridDefaultRowCount = 3;
const proPayerGridDefaultRowCount = 2;
const iPayerGridDefaultRowCount = 2;
const iConditionCodeGridDefaultRowCount = 5;
const ipLinesGridDefaultRowCount = 5;
const opLinesGridDefaultRowCount = 10;
const proLinesGridDefaultRowCount = 5;
const iOccurenceCodesGridDefaultRowCount = 4;
const iOccurenceSpanCodesGridDefaultRowCount = 2;
export const getInitialDatagridData = (addCaseManualFormData) => {
  const auditCaseLines = [];
  const diagnosesCaseCodes = [];
  const externalInjuryCodes = [];
  const icdProcedureCodes = [];
  const visitReasonCodes = [];
  const conditionCodes = [];
  const occurrenceSpanCodes = [];
  const occurrenceCodes = [];
  const auditCaseParticipants = [];
  var i = 0;
  if (addCaseManualFormData?.claimTypeCd === "P") {
    i = 0;
    for (i = 0; i < proDiagnosisGridDefaultRowCount; i++) {
      if (diagnosesCaseCodes.length >= proDiagnosisGridMaxRowCount) {
        return;
      }

      diagnosesCaseCodes.push({
        unique: new Guid().toString(),
        isDirty: false,
      });
    }

    for (i = 0; i < proLinesGridDefaultRowCount; i++) {
      auditCaseLines.push({
        unique: new Guid().toString(),
        isDirty: false,
      });
    }

    for (i = 0; i < iConditionCodeGridDefaultRowCount; i++) {
      conditionCodes.push({
        unique: new Guid().toString(),
        isDirty: false,
      });
    }

    for (i = 0; i < proPayerGridDefaultRowCount; i++) {
      auditCaseParticipants.push({
        unique: new Guid().toString(),
        isDirty: false,
      });
    }
  } else if (addCaseManualFormData?.claimTypeCd === "I") {
    if (addCaseManualFormData?.patientType === "IP") {
      for (i = 0; i < ipDiagnosisGridDefaultRowCount; i++) {
        diagnosesCaseCodes.push({
          unique: new Guid().toString(),
          isDirty: false,
        });
      }

      for (i = 0; i < ipICDProcedureGridDefaultRowCount; i++) {
        icdProcedureCodes.push({
          unique: new Guid().toString(),
          isDirty: false,
        });
      }

      for (i = 0; i < iExternalCauseOfInjuryGridDefaultRowCount; i++) {
        externalInjuryCodes.push({
          unique: new Guid().toString(),
          isDirty: false,
        });
      }

      for (i = 0; i < ipLinesGridDefaultRowCount; i++) {
        auditCaseLines.push({
          unique: new Guid().toString(),
          isDirty: false,
        });
      }

      for (i = 0; i < iConditionCodeGridDefaultRowCount; i++) {
        conditionCodes.push({
          unique: new Guid().toString(),
          isDirty: false,
        });
      }

      for (i = 0; i < iOccurenceCodesGridDefaultRowCount; i++) {
        occurrenceCodes.push({
          unique: new Guid().toString(),
          isDirty: false,
        });
      }

      for (i = 0; i < iOccurenceSpanCodesGridDefaultRowCount; i++) {
        occurrenceSpanCodes.push({
          unique: new Guid().toString(),
          isDirty: false,
        });
      }

      for (i = 0; i < iPayerGridDefaultRowCount; i++) {
        auditCaseParticipants.push({
          unique: new Guid().toString(),
          isDirty: false,
        });
      }
    } else if (addCaseManualFormData?.patientType === "OP") {
      for (i = 0; i < opDiagnosisGridDefaultRowCount; i++) {
        diagnosesCaseCodes.push({
          unique: new Guid().toString(),
          isDirty: false,
        });
      }

      for (i = 0; i < iExternalCauseOfInjuryGridDefaultRowCount; i++) {
        externalInjuryCodes.push({
          unique: new Guid().toString(),
          isDirty: false,
        });
      }

      for (i = 0; i < opVisitReasonGridDefaultRowCount; i++) {
        visitReasonCodes.push({
          unique: new Guid().toString(),
          isDirty: false,
        });
      }

      for (i = 0; i < opLinesGridDefaultRowCount; i++) {
        auditCaseLines.push({
          unique: new Guid().toString(),
          isDirty: false,
        });
      }

      for (i = 0; i < iConditionCodeGridDefaultRowCount; i++) {
        conditionCodes.push({
          unique: new Guid().toString(),
          isDirty: false,
        });
      }

      for (i = 0; i < iOccurenceCodesGridDefaultRowCount; i++) {
        occurrenceCodes.push({
          unique: new Guid().toString(),
          isDirty: false,
        });
      }

      for (i = 0; i < iOccurenceSpanCodesGridDefaultRowCount; i++) {
        occurrenceSpanCodes.push({
          unique: new Guid().toString(),
          isDirty: false,
        });
      }

      for (i = 0; i < iPayerGridDefaultRowCount; i++) {
        auditCaseParticipants.push({
          unique: new Guid().toString(),
          isDirty: false,
        });
      }
    }
  }
  return {
    auditCaseLines,
    diagnosesCaseCodes,
    externalInjuryCodes,
    icdProcedureCodes,
    visitReasonCodes,
    conditionCodes,
    occurrenceSpanCodes,
    occurrenceCodes,
    auditCaseParticipants,
  };
};

export const formatManualCaseObjectBeforeSave = (
  addCaseManualFormData,
  auditId,
  eaRoundId,
  addCaseToRoundNumber,
  roundStartDate,
  isForUpdate = false,

) => {
  let addCaseManualFormDataToSave = cloneDeep(addCaseManualFormData);
  if (isForUpdate) {
    return {
      auditId,
      eaCaseDetailId: addCaseManualFormDataToSave.eaCaseDetailId,
      auditOrgFieldId: null,
      eaCaseId: addCaseManualFormDataToSave.eaCaseId,
      auditCaseDetailAggregateId:
        addCaseManualFormDataToSave.auditCaseDetailAggregateId,
      auditCaseAggregateId: addCaseManualFormDataToSave.auditCaseAggregateId,
      attendingProviderId: addCaseManualFormDataToSave.attendingProviderId,
      billingProviderId: addCaseManualFormDataToSave.billingProviderId,
      renderingProviderId: addCaseManualFormDataToSave.renderingProviderId,
      facilityName: addCaseManualFormDataToSave.facilityName,
      patientAcctNo: addCaseManualFormDataToSave.patientAcctNo?.toUpperCase(),
      patientMRN: addCaseManualFormDataToSave.patientMRN?.toUpperCase(),
      patientFirstName: addCaseManualFormDataToSave.patientFirstName?.toUpperCase(),
      patientLastName: addCaseManualFormDataToSave.patientLastName?.toUpperCase(),
      attendingProvider: addCaseManualFormDataToSave.attendingProvider,
      admissionDateString: convertDate(
        addCaseManualFormDataToSave.admissionDateString
      ),
      admissionHrString: addCaseManualFormDataToSave.admitHourValue,
      dischargeDateString: convertDate(
        addCaseManualFormDataToSave.dischargeDateString
      ),
      dischargeHrString: addCaseManualFormDataToSave.dischargeHourValue,
      admitType: addCaseManualFormDataToSave.admissionTypeCode,
      dischargeStatus: addCaseManualFormDataToSave.dischargeStatus,
      originalPaymentAmount: addCaseManualFormDataToSave.originalPaymentAmt,
      clinicalTrialIdentifier:
        addCaseManualFormDataToSave.clinicalTrialIdentifier != null
          ? addCaseManualFormDataToSave.clinicalTrialIdentifier.toUpperCase()
          : null,
      investigationalDeviceExemptionNo:
        addCaseManualFormDataToSave.investDeviceExmptNo != null
          ? addCaseManualFormDataToSave.investDeviceExmptNo.toUpperCase()
          : null,
      claimTypeCd: addCaseManualFormDataToSave.claimTypeCd,
      patientType:
        addCaseManualFormDataToSave.claimTypeCd == "P"
          ? "OP"
          : addCaseManualFormDataToSave.patientType,
      drgDiagCode:
        addCaseManualFormDataToSave.drgDiagCode != null
          ? addCaseManualFormDataToSave.drgDiagCode.toUpperCase()
          : null,
      auditCaseLines: addCaseManualFormDataToSave.auditCaseLines,
      auditCaseParticipants: addCaseManualFormDataToSave.auditCaseParticipants,
      diagnosesCaseCodes: addCaseManualFormDataToSave.diagnosesCaseCodes,
      icdProcedureCodes: addCaseManualFormDataToSave.icdProcedureCodes,
      externalInjuryCodes: addCaseManualFormDataToSave.externalInjuryCodes,
      visitReasonCodes: addCaseManualFormDataToSave.visitReasonCodes,
      conditionCodes: addCaseManualFormDataToSave.conditionCodes,
      occurrenceCodes: addCaseManualFormDataToSave.occurrenceCodes,
      occurrenceSpanCodes: addCaseManualFormDataToSave.occurrenceSpanCodes,
      statementFromDateString: convertDate(
        addCaseManualFormDataToSave.statementFromDateString
      ),
      statementToDateString: convertDate(
        addCaseManualFormDataToSave.statementToDateString
      ),
      admitSource: addCaseManualFormDataToSave.admissionSourceCode,
      admittingDiagCode:
        addCaseManualFormDataToSave.admitDx != null
          ? addCaseManualFormDataToSave.admitDx.toUpperCase()
          : null,
      refCoderId: addCaseManualFormDataToSave.refCoderId  
    };
  }
  return {
    auditId: auditId,
    eaAuditId: auditId,
    eaRoundId,
    auditOrgFieldId: addCaseManualFormDataToSave.auditOrgFieldId
      ? addCaseManualFormDataToSave.auditOrgFieldId
      : null,
    patientAcctNo: addCaseManualFormDataToSave.patientAcctNo?.toUpperCase(),
    patientMRN: addCaseManualFormDataToSave.patientMRN?.toUpperCase(),
    patientFirstName: addCaseManualFormDataToSave.patientFirstName?.toUpperCase(),
    patientLastName: addCaseManualFormDataToSave.patientLastName?.toUpperCase(),
    facilityName: addCaseManualFormDataToSave.facilityName,
    attendingProviderId: addCaseManualFormDataToSave.attendingProviderId,
    billingProviderId: addCaseManualFormDataToSave.billingProviderId,
    renderingProviderId: addCaseManualFormDataToSave.renderingProviderId,
    admissionDateString: convertDate(
      addCaseManualFormDataToSave.admissionDateString
    ),
    admissionHrString: addCaseManualFormDataToSave.admitHourValue,
    dischargeDateString: convertDate(
      addCaseManualFormDataToSave.dischargeDateString
    ),
    dischargeHrString: addCaseManualFormDataToSave.dischargeHourValue,
    admitType: addCaseManualFormDataToSave.admissionTypeCode,
    dischargeStatus: addCaseManualFormDataToSave.dischargeStatus,
    originalPaymentAmount: addCaseManualFormDataToSave.originalPaymentAmt,
    clinicalTrialIdentifier:
      addCaseManualFormDataToSave.clinicalTrialIdentifier != null
        ? addCaseManualFormDataToSave.clinicalTrialIdentifier.toUpperCase()
        : null,
    investigationalDeviceExemptionNo:
      addCaseManualFormDataToSave.investDeviceExmptNo != null
        ? addCaseManualFormDataToSave.investDeviceExmptNo.toUpperCase()
        : null,
    claimTypeCd: addCaseManualFormDataToSave.claimTypeCd,
    patientType:
      addCaseManualFormDataToSave.claimTypeCd == "P"
        ? "OP"
        : addCaseManualFormDataToSave.patientType,
    drgDiagCode:
      addCaseManualFormDataToSave.drgDiagCode != null
        ? addCaseManualFormDataToSave.drgDiagCode.toUpperCase()
        : null,
    auditCaseLines: addCaseManualFormDataToSave.auditCaseLines,
    auditCaseParticipants: addCaseManualFormDataToSave.auditCaseParticipants,
    diagnosesCaseCodes: addCaseManualFormDataToSave.diagnosesCaseCodes,
    icdProcedureCodes: addCaseManualFormDataToSave.icdProcedureCodes,
    externalInjuryCodes: addCaseManualFormDataToSave.externalInjuryCodes,
    visitReasonCodes: addCaseManualFormDataToSave.visitReasonCodes,
    conditionCodes: addCaseManualFormDataToSave.conditionCodes,
    occurrenceCodes: addCaseManualFormDataToSave.occurrenceCodes,
    occurrenceSpanCodes: addCaseManualFormDataToSave.occurrenceSpanCodes,
    statementFromDateString: convertDate(
      addCaseManualFormDataToSave.statementFromDateString
    ),
    statementToDateString: convertDate(
      addCaseManualFormDataToSave.statementToDateString
    ),
    admitSource: addCaseManualFormDataToSave.admissionSourceCode,
    admittingDiagCode:
      addCaseManualFormDataToSave.admitDx != null
        ? addCaseManualFormDataToSave.admitDx.toUpperCase()
        : null,
    refCoderId: addCaseManualFormDataToSave.refCoderId,
    sequenceNo: addCaseToRoundNumber,
    roundStartDate:roundStartDate
  };
};

export const formatManualCaseObjectForView = (objectToFormat) =>{
  const resultFormattedObject = {...objectToFormat};
  resultFormattedObject.auditCaseLines?.forEach(x => x.unique = new Guid().toString());
  resultFormattedObject.auditCaseParticipants?.forEach(x => x.unique = new Guid().toString());
  resultFormattedObject.diagnosesCaseCodes?.forEach(x => x.unique = new Guid().toString());
  resultFormattedObject.icdProcedureCodes?.forEach(x => x.unique = new Guid().toString());
  resultFormattedObject.externalInjuryCodes?.forEach(x => x.unique = new Guid().toString());
  resultFormattedObject.visitReasonCodes?.forEach(x => x.unique = new Guid().toString());
  resultFormattedObject.conditionCodes?.forEach(x => x.unique = new Guid().toString());
  resultFormattedObject.occurrenceCodes?.forEach(x => x.unique = new Guid().toString());
  resultFormattedObject.occurrenceSpanCodes?.forEach(x => x.unique = new Guid().toString());
  return resultFormattedObject;
}